import React from 'react';
import { useScopedI18n } from '@locales/client';
import { HeadingMediumH5, BodyTextRegularB } from '@/shared/ui/typography2';
import { WrapperNotPay, Sum, Blocknfo, CloseIcon } from './styles';

type MethodUnavailableProps = {
  limit?: {
    min: number | string;
    max: number | string;
  };
  symbol?: string;
};

export const MethodUnavailable = ({
  limit,
  symbol = '',
}: MethodUnavailableProps) => {
  const t = useScopedI18n('wallet.withdraw');

  const { min, max } = limit || {};

  const messages = [
    { key: 'min_amount', value: min },
    { key: 'balance_message', value: max },
  ];

  return (
    <WrapperNotPay>
      <CloseIcon
        width={40}
        height={40}
        src="/images/icons/clock-pay.svg"
        alt={t('method_unavailable')}
      />

      <Blocknfo>
        <HeadingMediumH5>{t('method_unavailable')}</HeadingMediumH5>

        {messages.map(({ key, value }) => (
          <BodyTextRegularB key={key} color="#AFAFAF">
            {t(key)}:{' '}
            <Sum>
              {value || 0} {symbol}
            </Sum>
            .
          </BodyTextRegularB>
        ))}
      </Blocknfo>
    </WrapperNotPay>
  );
};
